import { InstitutionTableActions } from '@actions/institution-table/institution-table-actions';
import { UPDATE_INSTITUTION_TABLE } from '@actions/institution-table/types';
import { UpdateInstitutionTable } from '@reducers/types/institution-table/institution-table-state';

import {
  getFailedState,
  getRequestingState,
  getSuccessState,
} from '@utils/store';

const initialState: UpdateInstitutionTable = {
  request: false,
};

const updateInstitutionTableReducer = (
  state = initialState,
  action: InstitutionTableActions,
): UpdateInstitutionTable => {
  switch (action.type) {
    case UPDATE_INSTITUTION_TABLE.UPDATE_INSTITUTION_TABLE_REQUEST:
      return {
        ...getRequestingState(),
      };

    case UPDATE_INSTITUTION_TABLE.UPDATE_INSTITUTION_TABLE_SUCCESS:
      const { payload } = action as any;
      return {
        ...getSuccessState({ data: payload.data }),
      };

    case UPDATE_INSTITUTION_TABLE.UPDATE_INSTITUTION_TABLE_FAILED:
      return {
        ...getFailedState(),
      };

    default:
      return state;
  }
};

export default updateInstitutionTableReducer;
